/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Categories, ItemTypes, Items, Classification, RequestPriority } from '../model/itemselectionresponse';
import { CommonConstants } from '../../../../common/constants/common-constants';

@Injectable()
export class ItemSelectionService {

    constructor(public http: HttpClient) {
    }
    public getCategories(processIndex: string) {
        return this.http.get<Categories[]>(CommonConstants.SERVICE_VERSION_PATH_V1
             + '/customer/categories?requestType=' + processIndex);
    }

    public getItemTypes(categoryId , processIndex: string) {
        return this.http.get<ItemTypes[]>(
            CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/itemtypes?requestType='
            + processIndex + '&categoryId=' + categoryId);
    }

    public getItemID(itemTypeID , processIndex: string) {
        return this.http.get<Items[]>(
            CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/items?requestType='
            + processIndex + '&itemTypeId=' + itemTypeID);
    }

    public getItemSearch(processIndex, items) {
        return this.http.get<Items[]>(
            CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/requests/' + processIndex +
            '/items?itemNameSearchTerm=' + items + ' ');
    }
    public getClassification(itemTypeID) {
        return this.http.get<Classification[]>(
            CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/itemtype/classifications?itemTypeId=' + itemTypeID);
    }
    public getUrgencies() {
        return this.http.get<RequestPriority[]>(
            CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/urgencies');
    }
    public getPriorityBasedOnUrgency(itemID, urgencyID) {
        const requestOptions: Object = {
            responseType: 'text'
        };
        if (!urgencyID) {
            return this.http.get<String>(
                CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/urgencies/priority', requestOptions
                );
        } else {
            return this.http.get<String>(
                CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/urgencies/priority?itemId=' + itemID +
                '&urgencyId=' + urgencyID, requestOptions);
        }
    }
}
